import { render, staticRenderFns } from "./advertAdd.vue?vue&type=template&id=3fe48ac1"
import script from "./advertAdd.vue?vue&type=script&lang=js"
export * from "./advertAdd.vue?vue&type=script&lang=js"
import style0 from "./advertAdd.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports